import { render, staticRenderFns } from "./second_menuComputer_ICProductInfo.vue?vue&type=template&id=4aa61dda&scoped=true"
import script from "./second_menuComputer_ICProductInfo.vue?vue&type=script&lang=js"
export * from "./second_menuComputer_ICProductInfo.vue?vue&type=script&lang=js"
import style1 from "./second_menuComputer_ICProductInfo.vue?vue&type=style&index=1&id=4aa61dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa61dda",
  null
  
)

export default component.exports